import { ArrowUpRight } from "lucide-react";
import { FadeUp, KineticLine } from "@/components/KineticText";
import { ROTEIROS, whatsappLink } from "@/data/site";

export default function Roteiros() {
  return (
    <section
      data-testid="roteiros-section"
      className="mx-auto max-w-[1400px] px-6 py-24 md:px-12 md:py-40"
    >
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <FadeUp>
            <p className="text-xs font-medium uppercase tracking-[0.35em] text-dusk">
              Roteiros & Destinos
            </p>
          </FadeUp>
          <h2 className="mt-6 font-serif text-4xl font-light leading-[1.02] text-navy md:text-6xl">
            <KineticLine>Escolha o seu</KineticLine>
            <KineticLine delay={0.12}>
              <em className="italic text-sea">horizonte.</em>
            </KineticLine>
          </h2>
        </div>
        <FadeUp delay={0.15}>
          <p className="max-w-xs text-sm font-light leading-relaxed text-dusk md:text-right">
            Três sugestões para começar — o seu roteiro a gente desenha juntos.
          </p>
        </FadeUp>
      </div>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 md:mt-20 lg:grid-cols-3">
        {ROTEIROS.map((roteiro, i) => (
          <FadeUp key={roteiro.name} delay={i * 0.1} y={48} className="h-full">
            <article
              data-testid={`roteiro-card-${i}`}
              className="group flex h-full flex-col border border-cloud bg-paper transition-colors duration-300 hover:border-sea"
            >
              <div className="overflow-hidden">
                <img
                  src={roteiro.image}
                  alt={`Cruzeiro — ${roteiro.name}`}
                  loading="lazy"
                  className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
                />
              </div>
              <div className="flex flex-1 flex-col p-7">
                <p className="text-[0.65rem] font-medium uppercase tracking-[0.25em] text-sea">
                  {roteiro.route}
                </p>
                <h3 className="mt-3 font-serif text-2xl font-light text-navy md:text-3xl">
                  {roteiro.name}
                </h3>
                <p className="mt-3 flex-1 text-sm font-light leading-relaxed text-dusk">
                  {roteiro.description}
                </p>
                <a
                  href={whatsappLink(
                    `Olá! Quero um orçamento para o roteiro ${roteiro.name} (${roteiro.route}).`,
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`roteiro-cta-${i}`}
                  className="mt-8 inline-flex items-center gap-2 self-start border-b border-navy pb-1.5 text-[0.7rem] font-semibold uppercase tracking-[0.25em] text-navy transition-colors duration-300 hover:border-sea hover:text-sea"
                >
                  Pedir orçamento
                  <ArrowUpRight
                    size={14}
                    className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                  />
                </a>
              </div>
            </article>
          </FadeUp>
        ))}
      </div>

      <FadeUp delay={0.2}>
        <p className="mt-10 text-center font-serif text-base italic text-dusk md:text-lg">
          Roteiros de exemplo — o seu a gente desenha juntos, do jeito que você viaja.
        </p>
      </FadeUp>
    </section>
  );
}
